/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as WorkspaceIdRouteRouteImport } from './routes/$workspaceId/route'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as WorkspaceIdIndexRouteImport } from './routes/$workspaceId/index'
import { Route as PublicTeamRouteImport } from './routes/_public/team'
import { Route as PublicPricingRouteImport } from './routes/_public/pricing'
import { Route as PublicColorsRouteImport } from './routes/_public/colors'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as PublicAuthRouteRouteImport } from './routes/_public/_auth/route'
import { Route as WorkspaceIdProjectsRouteRouteImport } from './routes/$workspaceId/projects/route'
import { Route as WorkspaceIdStorageIndexRouteImport } from './routes/$workspaceId/storage/index'
import { Route as WorkspaceIdSettingsIndexRouteImport } from './routes/$workspaceId/settings/index'
import { Route as WorkspaceIdProjectsIndexRouteImport } from './routes/$workspaceId/projects/index'
import { Route as WorkspaceIdPasswordsIndexRouteImport } from './routes/$workspaceId/passwords/index'
import { Route as WorkspaceIdMeetsIndexRouteImport } from './routes/$workspaceId/meets/index'
import { Route as WorkspaceIdDocsIndexRouteImport } from './routes/$workspaceId/docs/index'
import { Route as WorkspaceIdChatsIndexRouteImport } from './routes/$workspaceId/chats/index'
import { Route as WorkspaceIdBoardsIndexRouteImport } from './routes/$workspaceId/boards/index'
import { Route as WorkspaceIdAutomationsIndexRouteImport } from './routes/$workspaceId/automations/index'
import { Route as WorkspaceIdAssistantIndexRouteImport } from './routes/$workspaceId/assistant/index'
import { Route as PublicAuthSignUpRouteImport } from './routes/_public/_auth/sign-up'
import { Route as PublicAuthSignInRouteImport } from './routes/_public/_auth/sign-in'
import { Route as WorkspaceIdStorageChannelIdRouteImport } from './routes/$workspaceId/storage/$channelId'
import { Route as WorkspaceIdPasswordsChannelIdRouteImport } from './routes/$workspaceId/passwords/$channelId'
import { Route as WorkspaceIdMeetsChannelIdRouteImport } from './routes/$workspaceId/meets/$channelId'
import { Route as WorkspaceIdDocsChannelIdRouteImport } from './routes/$workspaceId/docs/$channelId'
import { Route as WorkspaceIdChatsChannelIdRouteImport } from './routes/$workspaceId/chats/$channelId'
import { Route as WorkspaceIdBoardsChannelIdRouteImport } from './routes/$workspaceId/boards/$channelId'
import { Route as WorkspaceIdAutomationsChannelIdRouteImport } from './routes/$workspaceId/automations/$channelId'
import { Route as WorkspaceIdProjectsChannelIdDocsRouteImport } from './routes/$workspaceId/projects/$channelId/docs'
import { Route as WorkspaceIdProjectsChannelIdChatsRouteImport } from './routes/$workspaceId/projects/$channelId/chats'
import { Route as WorkspaceIdProjectsChannelIdBoardsRouteImport } from './routes/$workspaceId/projects/$channelId/boards'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceIdRouteRoute = WorkspaceIdRouteRouteImport.update({
  id: '/$workspaceId',
  path: '/$workspaceId',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const WorkspaceIdIndexRoute = WorkspaceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceIdRouteRoute,
} as any)
const PublicTeamRoute = PublicTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicPricingRoute = PublicPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicColorsRoute = PublicColorsRouteImport.update({
  id: '/colors',
  path: '/colors',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicAboutRoute = PublicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicAuthRouteRoute = PublicAuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => PublicRouteRoute,
} as any)
const WorkspaceIdProjectsRouteRoute =
  WorkspaceIdProjectsRouteRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdStorageIndexRoute = WorkspaceIdStorageIndexRouteImport.update({
  id: '/storage/',
  path: '/storage/',
  getParentRoute: () => WorkspaceIdRouteRoute,
} as any)
const WorkspaceIdSettingsIndexRoute =
  WorkspaceIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdProjectsIndexRoute =
  WorkspaceIdProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceIdProjectsRouteRoute,
  } as any)
const WorkspaceIdPasswordsIndexRoute =
  WorkspaceIdPasswordsIndexRouteImport.update({
    id: '/passwords/',
    path: '/passwords/',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdMeetsIndexRoute = WorkspaceIdMeetsIndexRouteImport.update({
  id: '/meets/',
  path: '/meets/',
  getParentRoute: () => WorkspaceIdRouteRoute,
} as any)
const WorkspaceIdDocsIndexRoute = WorkspaceIdDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => WorkspaceIdRouteRoute,
} as any)
const WorkspaceIdChatsIndexRoute = WorkspaceIdChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => WorkspaceIdRouteRoute,
} as any)
const WorkspaceIdBoardsIndexRoute = WorkspaceIdBoardsIndexRouteImport.update({
  id: '/boards/',
  path: '/boards/',
  getParentRoute: () => WorkspaceIdRouteRoute,
} as any)
const WorkspaceIdAutomationsIndexRoute =
  WorkspaceIdAutomationsIndexRouteImport.update({
    id: '/automations/',
    path: '/automations/',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdAssistantIndexRoute =
  WorkspaceIdAssistantIndexRouteImport.update({
    id: '/assistant/',
    path: '/assistant/',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const PublicAuthSignUpRoute = PublicAuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PublicAuthRouteRoute,
} as any)
const PublicAuthSignInRoute = PublicAuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicAuthRouteRoute,
} as any)
const WorkspaceIdStorageChannelIdRoute =
  WorkspaceIdStorageChannelIdRouteImport.update({
    id: '/storage/$channelId',
    path: '/storage/$channelId',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdPasswordsChannelIdRoute =
  WorkspaceIdPasswordsChannelIdRouteImport.update({
    id: '/passwords/$channelId',
    path: '/passwords/$channelId',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdMeetsChannelIdRoute =
  WorkspaceIdMeetsChannelIdRouteImport.update({
    id: '/meets/$channelId',
    path: '/meets/$channelId',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdDocsChannelIdRoute =
  WorkspaceIdDocsChannelIdRouteImport.update({
    id: '/docs/$channelId',
    path: '/docs/$channelId',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdChatsChannelIdRoute =
  WorkspaceIdChatsChannelIdRouteImport.update({
    id: '/chats/$channelId',
    path: '/chats/$channelId',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdBoardsChannelIdRoute =
  WorkspaceIdBoardsChannelIdRouteImport.update({
    id: '/boards/$channelId',
    path: '/boards/$channelId',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdAutomationsChannelIdRoute =
  WorkspaceIdAutomationsChannelIdRouteImport.update({
    id: '/automations/$channelId',
    path: '/automations/$channelId',
    getParentRoute: () => WorkspaceIdRouteRoute,
  } as any)
const WorkspaceIdProjectsChannelIdDocsRoute =
  WorkspaceIdProjectsChannelIdDocsRouteImport.update({
    id: '/$channelId/docs',
    path: '/$channelId/docs',
    getParentRoute: () => WorkspaceIdProjectsRouteRoute,
  } as any)
const WorkspaceIdProjectsChannelIdChatsRoute =
  WorkspaceIdProjectsChannelIdChatsRouteImport.update({
    id: '/$channelId/chats',
    path: '/$channelId/chats',
    getParentRoute: () => WorkspaceIdProjectsRouteRoute,
  } as any)
const WorkspaceIdProjectsChannelIdBoardsRoute =
  WorkspaceIdProjectsChannelIdBoardsRouteImport.update({
    id: '/$channelId/boards',
    path: '/$channelId/boards',
    getParentRoute: () => WorkspaceIdProjectsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$workspaceId': typeof WorkspaceIdRouteRouteWithChildren
  '/$workspaceId/projects': typeof WorkspaceIdProjectsRouteRouteWithChildren
  '/about': typeof PublicAboutRoute
  '/colors': typeof PublicColorsRoute
  '/pricing': typeof PublicPricingRoute
  '/team': typeof PublicTeamRoute
  '/$workspaceId/': typeof WorkspaceIdIndexRoute
  '/': typeof PublicIndexRoute
  '/$workspaceId/automations/$channelId': typeof WorkspaceIdAutomationsChannelIdRoute
  '/$workspaceId/boards/$channelId': typeof WorkspaceIdBoardsChannelIdRoute
  '/$workspaceId/chats/$channelId': typeof WorkspaceIdChatsChannelIdRoute
  '/$workspaceId/docs/$channelId': typeof WorkspaceIdDocsChannelIdRoute
  '/$workspaceId/meets/$channelId': typeof WorkspaceIdMeetsChannelIdRoute
  '/$workspaceId/passwords/$channelId': typeof WorkspaceIdPasswordsChannelIdRoute
  '/$workspaceId/storage/$channelId': typeof WorkspaceIdStorageChannelIdRoute
  '/sign-in': typeof PublicAuthSignInRoute
  '/sign-up': typeof PublicAuthSignUpRoute
  '/$workspaceId/assistant': typeof WorkspaceIdAssistantIndexRoute
  '/$workspaceId/automations': typeof WorkspaceIdAutomationsIndexRoute
  '/$workspaceId/boards': typeof WorkspaceIdBoardsIndexRoute
  '/$workspaceId/chats': typeof WorkspaceIdChatsIndexRoute
  '/$workspaceId/docs': typeof WorkspaceIdDocsIndexRoute
  '/$workspaceId/meets': typeof WorkspaceIdMeetsIndexRoute
  '/$workspaceId/passwords': typeof WorkspaceIdPasswordsIndexRoute
  '/$workspaceId/projects/': typeof WorkspaceIdProjectsIndexRoute
  '/$workspaceId/settings': typeof WorkspaceIdSettingsIndexRoute
  '/$workspaceId/storage': typeof WorkspaceIdStorageIndexRoute
  '/$workspaceId/projects/$channelId/boards': typeof WorkspaceIdProjectsChannelIdBoardsRoute
  '/$workspaceId/projects/$channelId/chats': typeof WorkspaceIdProjectsChannelIdChatsRoute
  '/$workspaceId/projects/$channelId/docs': typeof WorkspaceIdProjectsChannelIdDocsRoute
}
export interface FileRoutesByTo {
  '/about': typeof PublicAboutRoute
  '/colors': typeof PublicColorsRoute
  '/pricing': typeof PublicPricingRoute
  '/team': typeof PublicTeamRoute
  '/$workspaceId': typeof WorkspaceIdIndexRoute
  '/': typeof PublicIndexRoute
  '/$workspaceId/automations/$channelId': typeof WorkspaceIdAutomationsChannelIdRoute
  '/$workspaceId/boards/$channelId': typeof WorkspaceIdBoardsChannelIdRoute
  '/$workspaceId/chats/$channelId': typeof WorkspaceIdChatsChannelIdRoute
  '/$workspaceId/docs/$channelId': typeof WorkspaceIdDocsChannelIdRoute
  '/$workspaceId/meets/$channelId': typeof WorkspaceIdMeetsChannelIdRoute
  '/$workspaceId/passwords/$channelId': typeof WorkspaceIdPasswordsChannelIdRoute
  '/$workspaceId/storage/$channelId': typeof WorkspaceIdStorageChannelIdRoute
  '/sign-in': typeof PublicAuthSignInRoute
  '/sign-up': typeof PublicAuthSignUpRoute
  '/$workspaceId/assistant': typeof WorkspaceIdAssistantIndexRoute
  '/$workspaceId/automations': typeof WorkspaceIdAutomationsIndexRoute
  '/$workspaceId/boards': typeof WorkspaceIdBoardsIndexRoute
  '/$workspaceId/chats': typeof WorkspaceIdChatsIndexRoute
  '/$workspaceId/docs': typeof WorkspaceIdDocsIndexRoute
  '/$workspaceId/meets': typeof WorkspaceIdMeetsIndexRoute
  '/$workspaceId/passwords': typeof WorkspaceIdPasswordsIndexRoute
  '/$workspaceId/projects': typeof WorkspaceIdProjectsIndexRoute
  '/$workspaceId/settings': typeof WorkspaceIdSettingsIndexRoute
  '/$workspaceId/storage': typeof WorkspaceIdStorageIndexRoute
  '/$workspaceId/projects/$channelId/boards': typeof WorkspaceIdProjectsChannelIdBoardsRoute
  '/$workspaceId/projects/$channelId/chats': typeof WorkspaceIdProjectsChannelIdChatsRoute
  '/$workspaceId/projects/$channelId/docs': typeof WorkspaceIdProjectsChannelIdDocsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$workspaceId': typeof WorkspaceIdRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/$workspaceId/projects': typeof WorkspaceIdProjectsRouteRouteWithChildren
  '/_public/_auth': typeof PublicAuthRouteRouteWithChildren
  '/_public/about': typeof PublicAboutRoute
  '/_public/colors': typeof PublicColorsRoute
  '/_public/pricing': typeof PublicPricingRoute
  '/_public/team': typeof PublicTeamRoute
  '/$workspaceId/': typeof WorkspaceIdIndexRoute
  '/_public/': typeof PublicIndexRoute
  '/$workspaceId/automations/$channelId': typeof WorkspaceIdAutomationsChannelIdRoute
  '/$workspaceId/boards/$channelId': typeof WorkspaceIdBoardsChannelIdRoute
  '/$workspaceId/chats/$channelId': typeof WorkspaceIdChatsChannelIdRoute
  '/$workspaceId/docs/$channelId': typeof WorkspaceIdDocsChannelIdRoute
  '/$workspaceId/meets/$channelId': typeof WorkspaceIdMeetsChannelIdRoute
  '/$workspaceId/passwords/$channelId': typeof WorkspaceIdPasswordsChannelIdRoute
  '/$workspaceId/storage/$channelId': typeof WorkspaceIdStorageChannelIdRoute
  '/_public/_auth/sign-in': typeof PublicAuthSignInRoute
  '/_public/_auth/sign-up': typeof PublicAuthSignUpRoute
  '/$workspaceId/assistant/': typeof WorkspaceIdAssistantIndexRoute
  '/$workspaceId/automations/': typeof WorkspaceIdAutomationsIndexRoute
  '/$workspaceId/boards/': typeof WorkspaceIdBoardsIndexRoute
  '/$workspaceId/chats/': typeof WorkspaceIdChatsIndexRoute
  '/$workspaceId/docs/': typeof WorkspaceIdDocsIndexRoute
  '/$workspaceId/meets/': typeof WorkspaceIdMeetsIndexRoute
  '/$workspaceId/passwords/': typeof WorkspaceIdPasswordsIndexRoute
  '/$workspaceId/projects/': typeof WorkspaceIdProjectsIndexRoute
  '/$workspaceId/settings/': typeof WorkspaceIdSettingsIndexRoute
  '/$workspaceId/storage/': typeof WorkspaceIdStorageIndexRoute
  '/$workspaceId/projects/$channelId/boards': typeof WorkspaceIdProjectsChannelIdBoardsRoute
  '/$workspaceId/projects/$channelId/chats': typeof WorkspaceIdProjectsChannelIdChatsRoute
  '/$workspaceId/projects/$channelId/docs': typeof WorkspaceIdProjectsChannelIdDocsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$workspaceId'
    | '/$workspaceId/projects'
    | '/about'
    | '/colors'
    | '/pricing'
    | '/team'
    | '/$workspaceId/'
    | '/'
    | '/$workspaceId/automations/$channelId'
    | '/$workspaceId/boards/$channelId'
    | '/$workspaceId/chats/$channelId'
    | '/$workspaceId/docs/$channelId'
    | '/$workspaceId/meets/$channelId'
    | '/$workspaceId/passwords/$channelId'
    | '/$workspaceId/storage/$channelId'
    | '/sign-in'
    | '/sign-up'
    | '/$workspaceId/assistant'
    | '/$workspaceId/automations'
    | '/$workspaceId/boards'
    | '/$workspaceId/chats'
    | '/$workspaceId/docs'
    | '/$workspaceId/meets'
    | '/$workspaceId/passwords'
    | '/$workspaceId/projects/'
    | '/$workspaceId/settings'
    | '/$workspaceId/storage'
    | '/$workspaceId/projects/$channelId/boards'
    | '/$workspaceId/projects/$channelId/chats'
    | '/$workspaceId/projects/$channelId/docs'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/colors'
    | '/pricing'
    | '/team'
    | '/$workspaceId'
    | '/'
    | '/$workspaceId/automations/$channelId'
    | '/$workspaceId/boards/$channelId'
    | '/$workspaceId/chats/$channelId'
    | '/$workspaceId/docs/$channelId'
    | '/$workspaceId/meets/$channelId'
    | '/$workspaceId/passwords/$channelId'
    | '/$workspaceId/storage/$channelId'
    | '/sign-in'
    | '/sign-up'
    | '/$workspaceId/assistant'
    | '/$workspaceId/automations'
    | '/$workspaceId/boards'
    | '/$workspaceId/chats'
    | '/$workspaceId/docs'
    | '/$workspaceId/meets'
    | '/$workspaceId/passwords'
    | '/$workspaceId/projects'
    | '/$workspaceId/settings'
    | '/$workspaceId/storage'
    | '/$workspaceId/projects/$channelId/boards'
    | '/$workspaceId/projects/$channelId/chats'
    | '/$workspaceId/projects/$channelId/docs'
  id:
    | '__root__'
    | '/$workspaceId'
    | '/_public'
    | '/$workspaceId/projects'
    | '/_public/_auth'
    | '/_public/about'
    | '/_public/colors'
    | '/_public/pricing'
    | '/_public/team'
    | '/$workspaceId/'
    | '/_public/'
    | '/$workspaceId/automations/$channelId'
    | '/$workspaceId/boards/$channelId'
    | '/$workspaceId/chats/$channelId'
    | '/$workspaceId/docs/$channelId'
    | '/$workspaceId/meets/$channelId'
    | '/$workspaceId/passwords/$channelId'
    | '/$workspaceId/storage/$channelId'
    | '/_public/_auth/sign-in'
    | '/_public/_auth/sign-up'
    | '/$workspaceId/assistant/'
    | '/$workspaceId/automations/'
    | '/$workspaceId/boards/'
    | '/$workspaceId/chats/'
    | '/$workspaceId/docs/'
    | '/$workspaceId/meets/'
    | '/$workspaceId/passwords/'
    | '/$workspaceId/projects/'
    | '/$workspaceId/settings/'
    | '/$workspaceId/storage/'
    | '/$workspaceId/projects/$channelId/boards'
    | '/$workspaceId/projects/$channelId/chats'
    | '/$workspaceId/projects/$channelId/docs'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  WorkspaceIdRouteRoute: typeof WorkspaceIdRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspaceId': {
      id: '/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/$workspaceId'
      preLoaderRoute: typeof WorkspaceIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/$workspaceId/': {
      id: '/$workspaceId/'
      path: '/'
      fullPath: '/$workspaceId/'
      preLoaderRoute: typeof WorkspaceIdIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/_public/team': {
      id: '/_public/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof PublicTeamRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/pricing': {
      id: '/_public/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PublicPricingRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/colors': {
      id: '/_public/colors'
      path: '/colors'
      fullPath: '/colors'
      preLoaderRoute: typeof PublicColorsRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/about': {
      id: '/_public/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicAboutRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/_auth': {
      id: '/_public/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicAuthRouteRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/$workspaceId/projects': {
      id: '/$workspaceId/projects'
      path: '/projects'
      fullPath: '/$workspaceId/projects'
      preLoaderRoute: typeof WorkspaceIdProjectsRouteRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/storage/': {
      id: '/$workspaceId/storage/'
      path: '/storage'
      fullPath: '/$workspaceId/storage'
      preLoaderRoute: typeof WorkspaceIdStorageIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/settings/': {
      id: '/$workspaceId/settings/'
      path: '/settings'
      fullPath: '/$workspaceId/settings'
      preLoaderRoute: typeof WorkspaceIdSettingsIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/projects/': {
      id: '/$workspaceId/projects/'
      path: '/'
      fullPath: '/$workspaceId/projects/'
      preLoaderRoute: typeof WorkspaceIdProjectsIndexRouteImport
      parentRoute: typeof WorkspaceIdProjectsRouteRoute
    }
    '/$workspaceId/passwords/': {
      id: '/$workspaceId/passwords/'
      path: '/passwords'
      fullPath: '/$workspaceId/passwords'
      preLoaderRoute: typeof WorkspaceIdPasswordsIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/meets/': {
      id: '/$workspaceId/meets/'
      path: '/meets'
      fullPath: '/$workspaceId/meets'
      preLoaderRoute: typeof WorkspaceIdMeetsIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/docs/': {
      id: '/$workspaceId/docs/'
      path: '/docs'
      fullPath: '/$workspaceId/docs'
      preLoaderRoute: typeof WorkspaceIdDocsIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/chats/': {
      id: '/$workspaceId/chats/'
      path: '/chats'
      fullPath: '/$workspaceId/chats'
      preLoaderRoute: typeof WorkspaceIdChatsIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/boards/': {
      id: '/$workspaceId/boards/'
      path: '/boards'
      fullPath: '/$workspaceId/boards'
      preLoaderRoute: typeof WorkspaceIdBoardsIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/automations/': {
      id: '/$workspaceId/automations/'
      path: '/automations'
      fullPath: '/$workspaceId/automations'
      preLoaderRoute: typeof WorkspaceIdAutomationsIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/assistant/': {
      id: '/$workspaceId/assistant/'
      path: '/assistant'
      fullPath: '/$workspaceId/assistant'
      preLoaderRoute: typeof WorkspaceIdAssistantIndexRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/_public/_auth/sign-up': {
      id: '/_public/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicAuthSignUpRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/_public/_auth/sign-in': {
      id: '/_public/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicAuthSignInRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/$workspaceId/storage/$channelId': {
      id: '/$workspaceId/storage/$channelId'
      path: '/storage/$channelId'
      fullPath: '/$workspaceId/storage/$channelId'
      preLoaderRoute: typeof WorkspaceIdStorageChannelIdRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/passwords/$channelId': {
      id: '/$workspaceId/passwords/$channelId'
      path: '/passwords/$channelId'
      fullPath: '/$workspaceId/passwords/$channelId'
      preLoaderRoute: typeof WorkspaceIdPasswordsChannelIdRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/meets/$channelId': {
      id: '/$workspaceId/meets/$channelId'
      path: '/meets/$channelId'
      fullPath: '/$workspaceId/meets/$channelId'
      preLoaderRoute: typeof WorkspaceIdMeetsChannelIdRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/docs/$channelId': {
      id: '/$workspaceId/docs/$channelId'
      path: '/docs/$channelId'
      fullPath: '/$workspaceId/docs/$channelId'
      preLoaderRoute: typeof WorkspaceIdDocsChannelIdRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/chats/$channelId': {
      id: '/$workspaceId/chats/$channelId'
      path: '/chats/$channelId'
      fullPath: '/$workspaceId/chats/$channelId'
      preLoaderRoute: typeof WorkspaceIdChatsChannelIdRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/boards/$channelId': {
      id: '/$workspaceId/boards/$channelId'
      path: '/boards/$channelId'
      fullPath: '/$workspaceId/boards/$channelId'
      preLoaderRoute: typeof WorkspaceIdBoardsChannelIdRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/automations/$channelId': {
      id: '/$workspaceId/automations/$channelId'
      path: '/automations/$channelId'
      fullPath: '/$workspaceId/automations/$channelId'
      preLoaderRoute: typeof WorkspaceIdAutomationsChannelIdRouteImport
      parentRoute: typeof WorkspaceIdRouteRoute
    }
    '/$workspaceId/projects/$channelId/docs': {
      id: '/$workspaceId/projects/$channelId/docs'
      path: '/$channelId/docs'
      fullPath: '/$workspaceId/projects/$channelId/docs'
      preLoaderRoute: typeof WorkspaceIdProjectsChannelIdDocsRouteImport
      parentRoute: typeof WorkspaceIdProjectsRouteRoute
    }
    '/$workspaceId/projects/$channelId/chats': {
      id: '/$workspaceId/projects/$channelId/chats'
      path: '/$channelId/chats'
      fullPath: '/$workspaceId/projects/$channelId/chats'
      preLoaderRoute: typeof WorkspaceIdProjectsChannelIdChatsRouteImport
      parentRoute: typeof WorkspaceIdProjectsRouteRoute
    }
    '/$workspaceId/projects/$channelId/boards': {
      id: '/$workspaceId/projects/$channelId/boards'
      path: '/$channelId/boards'
      fullPath: '/$workspaceId/projects/$channelId/boards'
      preLoaderRoute: typeof WorkspaceIdProjectsChannelIdBoardsRouteImport
      parentRoute: typeof WorkspaceIdProjectsRouteRoute
    }
  }
}

interface WorkspaceIdProjectsRouteRouteChildren {
  WorkspaceIdProjectsIndexRoute: typeof WorkspaceIdProjectsIndexRoute
  WorkspaceIdProjectsChannelIdBoardsRoute: typeof WorkspaceIdProjectsChannelIdBoardsRoute
  WorkspaceIdProjectsChannelIdChatsRoute: typeof WorkspaceIdProjectsChannelIdChatsRoute
  WorkspaceIdProjectsChannelIdDocsRoute: typeof WorkspaceIdProjectsChannelIdDocsRoute
}

const WorkspaceIdProjectsRouteRouteChildren: WorkspaceIdProjectsRouteRouteChildren =
  {
    WorkspaceIdProjectsIndexRoute: WorkspaceIdProjectsIndexRoute,
    WorkspaceIdProjectsChannelIdBoardsRoute:
      WorkspaceIdProjectsChannelIdBoardsRoute,
    WorkspaceIdProjectsChannelIdChatsRoute:
      WorkspaceIdProjectsChannelIdChatsRoute,
    WorkspaceIdProjectsChannelIdDocsRoute:
      WorkspaceIdProjectsChannelIdDocsRoute,
  }

const WorkspaceIdProjectsRouteRouteWithChildren =
  WorkspaceIdProjectsRouteRoute._addFileChildren(
    WorkspaceIdProjectsRouteRouteChildren,
  )

interface WorkspaceIdRouteRouteChildren {
  WorkspaceIdProjectsRouteRoute: typeof WorkspaceIdProjectsRouteRouteWithChildren
  WorkspaceIdIndexRoute: typeof WorkspaceIdIndexRoute
  WorkspaceIdAutomationsChannelIdRoute: typeof WorkspaceIdAutomationsChannelIdRoute
  WorkspaceIdBoardsChannelIdRoute: typeof WorkspaceIdBoardsChannelIdRoute
  WorkspaceIdChatsChannelIdRoute: typeof WorkspaceIdChatsChannelIdRoute
  WorkspaceIdDocsChannelIdRoute: typeof WorkspaceIdDocsChannelIdRoute
  WorkspaceIdMeetsChannelIdRoute: typeof WorkspaceIdMeetsChannelIdRoute
  WorkspaceIdPasswordsChannelIdRoute: typeof WorkspaceIdPasswordsChannelIdRoute
  WorkspaceIdStorageChannelIdRoute: typeof WorkspaceIdStorageChannelIdRoute
  WorkspaceIdAssistantIndexRoute: typeof WorkspaceIdAssistantIndexRoute
  WorkspaceIdAutomationsIndexRoute: typeof WorkspaceIdAutomationsIndexRoute
  WorkspaceIdBoardsIndexRoute: typeof WorkspaceIdBoardsIndexRoute
  WorkspaceIdChatsIndexRoute: typeof WorkspaceIdChatsIndexRoute
  WorkspaceIdDocsIndexRoute: typeof WorkspaceIdDocsIndexRoute
  WorkspaceIdMeetsIndexRoute: typeof WorkspaceIdMeetsIndexRoute
  WorkspaceIdPasswordsIndexRoute: typeof WorkspaceIdPasswordsIndexRoute
  WorkspaceIdSettingsIndexRoute: typeof WorkspaceIdSettingsIndexRoute
  WorkspaceIdStorageIndexRoute: typeof WorkspaceIdStorageIndexRoute
}

const WorkspaceIdRouteRouteChildren: WorkspaceIdRouteRouteChildren = {
  WorkspaceIdProjectsRouteRoute: WorkspaceIdProjectsRouteRouteWithChildren,
  WorkspaceIdIndexRoute: WorkspaceIdIndexRoute,
  WorkspaceIdAutomationsChannelIdRoute: WorkspaceIdAutomationsChannelIdRoute,
  WorkspaceIdBoardsChannelIdRoute: WorkspaceIdBoardsChannelIdRoute,
  WorkspaceIdChatsChannelIdRoute: WorkspaceIdChatsChannelIdRoute,
  WorkspaceIdDocsChannelIdRoute: WorkspaceIdDocsChannelIdRoute,
  WorkspaceIdMeetsChannelIdRoute: WorkspaceIdMeetsChannelIdRoute,
  WorkspaceIdPasswordsChannelIdRoute: WorkspaceIdPasswordsChannelIdRoute,
  WorkspaceIdStorageChannelIdRoute: WorkspaceIdStorageChannelIdRoute,
  WorkspaceIdAssistantIndexRoute: WorkspaceIdAssistantIndexRoute,
  WorkspaceIdAutomationsIndexRoute: WorkspaceIdAutomationsIndexRoute,
  WorkspaceIdBoardsIndexRoute: WorkspaceIdBoardsIndexRoute,
  WorkspaceIdChatsIndexRoute: WorkspaceIdChatsIndexRoute,
  WorkspaceIdDocsIndexRoute: WorkspaceIdDocsIndexRoute,
  WorkspaceIdMeetsIndexRoute: WorkspaceIdMeetsIndexRoute,
  WorkspaceIdPasswordsIndexRoute: WorkspaceIdPasswordsIndexRoute,
  WorkspaceIdSettingsIndexRoute: WorkspaceIdSettingsIndexRoute,
  WorkspaceIdStorageIndexRoute: WorkspaceIdStorageIndexRoute,
}

const WorkspaceIdRouteRouteWithChildren =
  WorkspaceIdRouteRoute._addFileChildren(WorkspaceIdRouteRouteChildren)

interface PublicAuthRouteRouteChildren {
  PublicAuthSignInRoute: typeof PublicAuthSignInRoute
  PublicAuthSignUpRoute: typeof PublicAuthSignUpRoute
}

const PublicAuthRouteRouteChildren: PublicAuthRouteRouteChildren = {
  PublicAuthSignInRoute: PublicAuthSignInRoute,
  PublicAuthSignUpRoute: PublicAuthSignUpRoute,
}

const PublicAuthRouteRouteWithChildren = PublicAuthRouteRoute._addFileChildren(
  PublicAuthRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicAuthRouteRoute: typeof PublicAuthRouteRouteWithChildren
  PublicAboutRoute: typeof PublicAboutRoute
  PublicColorsRoute: typeof PublicColorsRoute
  PublicPricingRoute: typeof PublicPricingRoute
  PublicTeamRoute: typeof PublicTeamRoute
  PublicIndexRoute: typeof PublicIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicAuthRouteRoute: PublicAuthRouteRouteWithChildren,
  PublicAboutRoute: PublicAboutRoute,
  PublicColorsRoute: PublicColorsRoute,
  PublicPricingRoute: PublicPricingRoute,
  PublicTeamRoute: PublicTeamRoute,
  PublicIndexRoute: PublicIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  WorkspaceIdRouteRoute: WorkspaceIdRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
